export default __webpack_public_path__ + "static/media/OAA.a6629fe9.png";